import { ReactNode, isValidElement } from "react";

export const InputLabel = (props: { label?: string | JSX.Element; className?: string }) => {
    if (props.label === undefined) return <></>;

    let isValidReactNode = isValidElement(props.label);
    return (
        <>
            {isValidReactNode ? (
                <label className="is-size-7">
                    <span className="ml-2">{props.label}</span>
                </label>
            ) : (
                <>
                    {props.label && (
                        <label className="is-size-7">
                            <span className="ml-2" dangerouslySetInnerHTML={{ __html: props.label as string }}></span>
                        </label>
                    )}
                </>
            )}
        </>
    );
};
